import { Link } from 'react-router-dom'
import { useLanguage } from '../../contexts/LanguageContext'

const Footer = () => {
  const { t } = useLanguage()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-black border-t border-white/10 pt-20 pb-10 px-6 md:px-20 relative z-10">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-10">
        {/* Logo */}
        <div className="flex flex-col gap-4">
          <Link to="/" className="flex items-center">
            <img src="/logo.png" alt="xDT" className="h-6" />
          </Link>
        </div>

        {/* Links */}
        <div className="flex flex-wrap gap-8 md:gap-16 font-mono">
          <Link to="/about" className="footer-link">{t('nav.about')}</Link>
          <Link to="/products" className="footer-link">{t('nav.products')}</Link>
          <Link to="/careers" className="footer-link">{t('nav.careers')}</Link>
          <Link to="/contact" className="footer-link">{t('nav.contact')}</Link>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-center items-center gap-4">
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
          <p className="text-[9px] text-gray-700 font-mono tracking-widest">
            © {currentYear} {t('company.name')} INC. ALL RIGHTS RESERVED.
          </p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[9px] text-gray-700 font-mono tracking-widest hover:text-white transition-colors"
          >
            沪ICP备2025136332号
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
